import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0909f5b9")

_pushScopeId("data-v-0909f5b9")
const _hoisted_1 = { style: {"background-color":"#2f3242"} }
const _hoisted_2 = /*#__PURE__*/_createVNode("svg", {
  width: "380px",
  height: "500px",
  viewBox: "0 0 837 1045",
  version: "1.1"
}, [
  /*#__PURE__*/_createVNode("g", {
    id: "Page-1",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd",
    "sketch:type": "MSPage"
  }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M353,9 L626.664028,170 L626.664028,487 L353,642 L79.3359724,487 L79.3359724,170 L353,9 Z",
      id: "Polygon-1",
      stroke: "#007FB2",
      "stroke-width": "6",
      "sketch:type": "MSShapeGroup"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M78.5,529 L147,569.186414 L147,648.311216 L78.5,687 L10,648.311216 L10,569.186414 L78.5,529 Z",
      id: "Polygon-2",
      stroke: "#EF4A5B",
      "stroke-width": "6",
      "sketch:type": "MSShapeGroup"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M773,186 L827,217.538705 L827,279.636651 L773,310 L719,279.636651 L719,217.538705 L773,186 Z",
      id: "Polygon-3",
      stroke: "#795D9C",
      "stroke-width": "6",
      "sketch:type": "MSShapeGroup"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M639,529 L773,607.846761 L773,763.091627 L639,839 L505,763.091627 L505,607.846761 L639,529 Z",
      id: "Polygon-4",
      stroke: "#F2773F",
      "stroke-width": "6",
      "sketch:type": "MSShapeGroup"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M281,801 L383,861.025276 L383,979.21169 L281,1037 L179,979.21169 L179,861.025276 L281,801 Z",
      id: "Polygon-5",
      stroke: "#36B455",
      "stroke-width": "6",
      "sketch:type": "MSShapeGroup"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "message-box" }, [
  /*#__PURE__*/_createVNode("h1", null, "404"),
  /*#__PURE__*/_createVNode("p", null, "Page not found"),
  /*#__PURE__*/_createVNode("div", { class: "buttons-con" }, [
    /*#__PURE__*/_createVNode("div", { class: "action-link-wrap" }, [
      /*#__PURE__*/_createVNode("a", {
        onclick: "history.back(-1)",
        class: "link-button link-back-button"
      }, "Go Back"),
      /*#__PURE__*/_createVNode("a", {
        href: "/",
        class: "link-button"
      }, "Go to Home Page")
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withId(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    })
  ]))
})